module.exports = __webpack_public_path__ + "static/media/Search.d6f391cb.svg";